import { request } from '@/utils/request';

const upload = async (url, file) => {
  const data = new FormData();
  data.append('image', file);
  return (await request.post(url, data, { timeout: 30000 })).data;
};
export const uploadAvatar = file => upload('/user/avatar/', file);
export const uploadPostImage = (postId, file) => upload(`/post/${postId}/images/`, file);

// 逐张上传，只保留失败的文件供用户重试，避免再次提交已经成功的图片。
export const uploadSelectedImages = async (postId, files, onUploaded = () => {}) => {
  const failed = [];
  for (const file of files) {
    try {
      const image = await uploadPostImage(postId, file.originFileObj || file);
      if (!image?.id || !image.image_url) throw new Error('图片上传响应无效');
      onUploaded(image);
    } catch (error) { failed.push({ ...file, status: 'error', error }); }
  }
  return failed;
};
